export default __webpack_public_path__ + "static/media/CC10-ETH.ddfa55ba.png";